<template>
  <div v-for="(src, index) in posts" :key="index">
    <div @click="() => showImg(index)">
      <img role="button" class="img-fluid" :src="src" />
    </div>
  </div>
  <VueEasyLightbox :visible="visibleRef" :imgs="posts" :index="indexRef" @hide="onHide" />
</template>

<script setup>
const props = defineProps({
  images: String,
});

const posts = computed(() => {
  return props.images.split(",");
});

import VueEasyLightbox from 'vue-easy-lightbox'

const visibleRef = ref(false);
const indexRef = ref(0);
const showImg = (index) => {
  indexRef.value = index;
  visibleRef.value = true;
};
const onHide = () => (visibleRef.value = false);
</script>
